import { useQuery, useMutation } from "@tanstack/react-query";
import { client } from "services/api-client";

export const useGetTicketsDetailList = (data: {
  status: string | null;
  assignmentGroup: string | null;
  activityType: string | null;
  customerId: string | null;
  period: string;
  pageNumber?: number;
  pageRowCount?: number;
  region?: string;
  vaultAccessRequired?: boolean;
  carriedOverCalls?: boolean;
  loggedToday?: boolean;
}) =>
  useQuery({
    queryKey: [
      "GetTicketsDetailList",
      data.status,
      data.customerId,
      data.assignmentGroup,
      data.activityType,
      data.region,
      data.pageNumber,
      data.vaultAccessRequired,
      data.carriedOverCalls,
      data.loggedToday
    ],
    queryFn: () => client(`tickets/ccdashboard/detail`, { data })
  });
export const useExportTicketsDetailList = () =>
  useMutation({
    mutationFn: (data: {
      status: string | null;
      assignmentGroup: string | null;
      activityType: string | null;
      customerId: string | null;
      period: string;
      region?: string;
      vaultAccessRequired?: boolean;
      carriedOverCalls?: boolean;
      loggedToday?: boolean;
    }) => client(`tickets/ccdashboard/detail/export`, { data })
  });

export const useGetDashboardStats = () =>
  useMutation({
    mutationFn: (data: {
      status: string | null;
      assignmentGroup: string | null;
      activityType: string | null;
      customerId: string | null;
      period: string;
      pageNumber?: number;
      pageRowCount?: number;
      region?: string;
      vaultAccessRequired?: boolean;
      carriedOverCalls?: boolean;
      loggedToday?: boolean;
    }) => client(`tickets/ccdashboard/service-tickets/stats`, { data })
  });

export const useGetDashboardMaintenanceStats = () =>
  useMutation({
    mutationFn: (data: {
      status: string | null;
      assignmentGroup: string | null;
      activityType: string | null;
      customerId: string | null;
      period: string;
      pageNumber?: number;
      pageRowCount?: number;
      region?: string;
      vaultAccessRequired?: boolean;
      carriedOverCalls?: boolean;
      loggedToday?: boolean;
    }) => client(`tickets/ccdashboard/maintenance-services/stats`, { data })
  });
